import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pt-forgot-message',
  template: `
    <div class='mb-4'>
      <ngb-alert *ngIf='success' [type]="'success'" [dismissible]='false' [animation]='true'>{{ message }}</ngb-alert>
      <ngb-alert *ngIf='!success' [type]="'warning'" [dismissible]='false' [animation]='true'>{{ message }}</ngb-alert>
    </div>

    <pt-sign-actions
      [cancelLabel]='cancelLabel'
      [confirmLabel]='confirmLabel'
      [showConfirm]='false'
      [showCancel]='true'
      (onCancel)='onCancel.emit()'>
    </pt-sign-actions>
  `
})
export class ForgotMessageComponent {

  @Input() success: boolean;
  @Input() message: string;
  @Input() cancelLabel: string;
  @Input() confirmLabel: string;

  @Output() onCancel = new EventEmitter();

}
